import './theme.css';
import { defineMessages, type MessageDescriptor } from 'react-intl';
import type { AgentLogo } from '@/app/lib/stage/StageHeader.tsx';

const siteMessages = defineMessages({
  askPlaceholder: {
    id: 'composer.businessPrompt',
    defaultMessage: 'Ask about a custom build, pricing or a visit…',
    description: 'Invitation shown inside the empty Lakdi Studio composer.',
  },
});

export interface SiteConfig {
  brandName: string;
  /** Optional owner-supplied brand mark. */
  logo?: AgentLogo;
  /** The assistant's appearance. */
  appearance: 'light' | 'dark' | 'auto';
  /** Composer invitation. */
  placeholder?: MessageDescriptor;
}

export const SITE_CONFIG: SiteConfig = {
  brandName: 'Lakdi Studio – Custom Furniture & Interiors',
  appearance: 'light',
  placeholder: siteMessages.askPlaceholder,
};
